import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { clearSession, createSession, readSession } from "./session.js";
const Ctx = createContext(null);
export function SessionProvider({ children }) {
    const [session, setSession] = useState(() => readSession());
    const signIn = useCallback((input) => {
        const s = createSession(input);
        setSession(s);
        return s;
    }, []);
    const signOut = useCallback(() => {
        clearSession();
        setSession(null);
    }, []);
    const value = useMemo(() => ({ session, signIn, signOut }), [session, signIn, signOut]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useSession() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("useSession must be used inside <SessionProvider>");
    return v;
}
